import React, { useMemo } from "react";
import ReservationOccupants from "../../../Occupants/ReservationOccupants";
import { useCart, useScrollTop, useSession } from "@hooks";
import { useSearchParams } from "react-router-dom";

type StepReservationContentProps = {
  showDiscountsBlock?: boolean;
  showProductOccupant?: boolean;
};

const languagesVarsCodes = [
  "LANG_neobooking_occupant_adding_in_progress", //Ajout d'un occupant en cours
  "LANG_neobooking_occupant_add", //Ajouter un occupant
  "LANG_neobooking_occupant_successfully_added", //Un occupant a bien été ajouté !
  "LANG_neobooking_occupant_baby_adding_in_progress", //Ajout d'un bébé en cours...
  "LANG_neobooking_occupant_baby_add", //Ajouter un bébé
  "LANG_neobooking_occupant_baby_successfully_added", //Un bébé a bien été ajouté !
  "LANG_neobooking_product_global_title", //Options par hébergement
];

const StepReservationContent: React.FC<StepReservationContentProps> = ({
  showDiscountsBlock = true,
  showProductOccupant = true,
}) => {
  /* Hooks */
  const { cart } = useCart();
  const { getLanguageVarValue } = useSession();
  const [searchParams] = useSearchParams();
  useScrollTop();

  const isEdit = searchParams.get("edit") === "1";
  const canAddOccupant = useMemo(() => {
    if (isEdit) {
      const isVACAF =
        cart?.reservations?.[0]?.contractFolder?.cmsCriterias?.find(
          (x) => x?.code === "AFCI"
        )?.value === "1";
      return isVACAF ? false : true;
    } else {
      return true;
    }
  }, []);

  const canEditOccupant = useMemo(() => {
    if (isEdit) {
      const isVACAF =
        cart?.reservations?.[0]?.contractFolder?.cmsCriterias?.find(
          (x) => x?.code === "AFCI"
        )?.value === "1";
      return isVACAF ? false : true;
    } else {
      return true;
    }
  }, []);

  return (
    <>
      <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-2">
        <div className="tw-w-full">
          <div className="tw-mb-8">
            <div className="tw-flex tw-flex-col tw-gap-2">
              {cart?.reservations?.map((reservation, reservationIndex) => {
                return (
                  reservation && (
                    <div
                      key={`reservation_${reservation?.id}_${reservationIndex}`}
                    >
                      <div>
                        <ReservationOccupants
                          btnAddOccupantText={getLanguageVarValue(
                            "LANG_neobooking_occupant_add"
                          )}
                          loadingAddingOccupantText={getLanguageVarValue(
                            "LANG_neobooking_occupant_adding_in_progress"
                          )}
                          successfullyOccupantAddedText={getLanguageVarValue(
                            "LANG_neobooking_occupant_successfully_added"
                          )}
                          productListTitle={getLanguageVarValue(
                            "LANG_neobooking_product_global_title"
                          )}
                          reservation={reservation}
                          btnAddBabyText={getLanguageVarValue(
                            "LANG_neobooking_occupant_baby_add"
                          )}
                          successfullyBabyAddedText={getLanguageVarValue(
                            "LANG_neobooking_occupant_baby_successfully_added"
                          )}
                          loadingAddingBabyText={getLanguageVarValue(
                            "LANG_neobooking_occupant_baby_adding_in_progress"
                          )}
                          showProductOccupant={showProductOccupant}
                          showAddOccupant={canAddOccupant}
                          canEditOccupant={canEditOccupant}
                        />
                      </div>
                    </div>
                  )
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

StepReservationContent.propTypes = {
  //
};

export default StepReservationContent;
